(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSupportDetails() {
      document.querySelectorAll('.support-details-wrapper').forEach(function (wrapper) {
        var accordion = wrapper.querySelector('.support-details-accordion');
        var summary = wrapper.querySelector('.support-details-summary');

        if (!accordion) return;

        var breakpoint = parseInt(wrapper.getAttribute('data-breakpoint'), 10) || 750;
        var mobileDefaultOpen = wrapper.getAttribute('data-mobile-default-open') === 'true';
        var desktopForceOpen = wrapper.getAttribute('data-desktop-force-open') === 'true';
        var isDesktop = window.innerWidth >= breakpoint;

        wrapper.classList.toggle('is-desktop', isDesktop);
        wrapper.classList.toggle('is-mobile', !isDesktop);
        wrapper.classList.toggle('desktop-force-open', isDesktop && desktopForceOpen);
        wrapper.classList.toggle('allow-desktop-toggle', isDesktop && !desktopForceOpen);

        if (isDesktop) {
          if (desktopForceOpen) {
            accordion.setAttribute('open', '');
            if (summary) {
              summary.style.pointerEvents = 'none';
              summary.style.cursor = 'default';
            }
          } else {
            if (summary) {
              summary.style.pointerEvents = '';
              summary.style.cursor = 'pointer';
            }
          }
        } else {
          if (mobileDefaultOpen) {
            accordion.setAttribute('open', '');
          } else {
            accordion.removeAttribute('open');
          }

          if (summary) {
            summary.style.pointerEvents = '';
            summary.style.cursor = 'pointer';
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSupportDetails);
    } else {
      initSupportDetails();
    }

    document.addEventListener('shopify:section:load', initSupportDetails);

    var supportResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(supportResizeTimer);
      supportResizeTimer = setTimeout(initSupportDetails, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
